<template>
    <div class="shadow-md p-3 w-full">
      <div class="flex gap-2 mb-5">
        <button @click="tipo = 'p'" class="btn" :class="{'btn-success': tipo == 'p'}">Pendientes</button>
        <button @click="tipo = 'h'" class="btn" :class="{'btn-success': tipo == 'h'}">Historicos</button>
      </div>
      <!-- <div class="flex cursor-pointer" @click="pedPendientes = !pedPendientes">
        <p>Pedidos Pendientes</p>
        <div :class="{'arrow': pedPendientes}">&#9650;</div>
      </div> -->
      <div v-show="tipo == 'p'" class="h-full">
        <table class="table table-striped table-sm text-sm">
          <thead>
            <tr>
              <th scope="col">Nombre</th>
              <th scope="col">Email</th>
              <th scope="col">Cuit</th>
              <th scope="col">Vendedor</th>
              <th scope="col">Total</th>
              <th scope="col">Items</th>
              <th scope="col">Fecha</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody v-if="carritosUsuarios.length > 0">
            <tr v-for="(user, key) in carritosUsuarios" class="px-0" :key="key">
              <td>{{ user.razon }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.cuit }}</td>
              <td>{{ user.vendedor }}</td>
              <td>${{ user.total.toFixed(2) }}</td>
              <td>{{ user.items }}</td>
              <td>{{ formatDate(user.fecha) }}</td>
              <td><button class="btn btn-outline-primary btn-sm" @click="verCarrito(user.id, user.razon, user.idcli ? user.idcli : null)">Ver carrito</button></td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td>No hay pedidos pendientes..</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <div class="flex cursor-pointer" @click="pedHistoricos = !pedHistoricos">
        <p>Pedidos Historicos</p>
        <div :class="{'arrow': pedHistoricos}">&#9650;</div>
      </div> -->
      <div v-show="tipo == 'h'" class="h-full">
        <div class="flex gap-5">
          <button class="btn btn-sm btn-primary" @click="index--; cargarHistoricos()" :disabled="index <= 1 || loading">Anterior</button>
          <p>Pag. {{ index }}</p>
          <button class="btn btn-sm btn-primary" @click="index++; cargarHistoricos()" :disabled="pedidosUsuarios.length < 20 || loading">Siguiente</button>
          <input @change="cargarHistoricos" type="text" placeholder="Razon Social" class="form-control" v-model="razonsocialBuscador"/>
        </div>
        <table class="table table-striped table-sm text-sm">
          <thead>
            <tr>
              <th scope="col">Nro WEB</th>
              <th scope="col">Nro Pedido</th>
              <th scope="col">Direccion</th>
              <th scope="col">Fecha</th>
              <th scope="col">Cliente</th>
              <th scope="col">Total</th>
              <th scope="col">Cant. items</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody v-if="pedidosUsuarios.length > 0">
            <tr v-for="(ped, key) in pedidosUsuarios" class="px-0" :key="key">
              <td>{{ ped.IDCON_PED }}</td>
              <td>{{ ped.NUMERO_PED }}</td>
              <td>{{ ped.DIRECCION_PED }}</td>
              <td>{{ formatDate(ped.FECHA_CARGA_PED) }}</td>
              <td>{{ ped.razon }}</td>
              <td>{{ ped.IMPORTE_CP.toFixed(2) }}</td>
              <td>{{ ped.items.length }}</td>
              <td><button class="btn btn-outline-primary btn-sm" @click="verItems(ped.items)">Ver Items</button></td>
              <td>
                <button class="btn btn-outline-success btn-sm" :disabled="cargando" @click="repetirPedido(ped)">Repetir pedido</button>
                <button class="btn btn-outline-success btn-sm" :disabled="cargando" @click="repetirPedidoCambioCli(ped)">a otro cliente</button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td>No hay pedidos aun..</td>
            </tr>
          </tbody>
        </table>
      </div>


      <div class="modal" id="borrarCarrito">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            
            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Repetir pedido</h4>
            </div>
            
            <!-- Modal body -->
            <div class="modal-body">
             <p>Actualmente posee articulos en el carrito, desea eliminarlos?</p>
            </div>
          
            <!-- Modal footer -->
            <div class="modal-footer">
                <button class="btn btn-success" @click="borrarYrepetir()">Borrar articulos y repetir pedido</button>
                <button class="btn btn-danger bg-truered" data-bs-dismiss="modal">Cancelar</button>
            </div>

          </div>
        </div>
      </div>

      <div class="modal" id="repetirPedDistUsu">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            
            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Repetir pedido a usuario:</h4>
            </div>
              
              <!-- Modal body -->
            <div class="modal-body">
              <div class="flex flex-wrap justify-center items-center p-2">
                <input type="text" class="form-control w-44" v-model="filtroClientes" @change="updateIdcli()" placeholder="Buscar cliente..">
                <div class="flex flex-wrap justify-center items-center p-2">
                  <p>Cliente: </p>
                  <select placeholder="Seleccione un cliente" class="form-select w-72" v-model="idcli">
                    <option value="" disabled selected hidden>Seleccione un cliente</option>
                    <option v-for="(ex, key) in clientesFiltrados" :key="key" :value="ex.id">{{ ex.descripcion }}</option>
                  </select>
                </div>
              </div> 
            </div>
          
            <!-- Modal footer -->
            <div class="modal-footer">
                <button class="btn btn-success" @click="repetirAusu()">repetir pedido</button>
                <button class="btn btn-danger bg-truered" data-bs-dismiss="modal">Cancelar</button>
            </div>

          </div>
        </div>
      </div>


      <div class="modal" id="itemsPed">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            
            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Items del pedido</h4>
            </div>
            
            <!-- Modal body -->
            <div class="modal-body">
              <table class="table table-striped table-sm text-sm">
                <thead>
                  <tr>
                    <th scope="col">Codigo</th>
                    <th scope="col">Descripcion</th>
                    <th scope="col">Precio unitario</th>
                    <th scope="col">cantidad</th>
                    <th scope="col">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in items" class="px-0" :key="key">
                    <td>{{ item.CODIGO_ART }}</td>
                    <td>{{ item.DESCRIP_ART }}</td>
                    <td>${{ item.PRECIO_LPI.toFixed(2) }}</td>
                    <td>{{ item.CANTIDAD_PEDI }}</td>
                    <td>${{ (Number(item.PRECIO_LPI) * Number(item.CANTIDAD_PEDI)).toFixed(2) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          
            <!-- Modal footer -->
            <div class="modal-footer">
                <button class="btn btn-danger bg-truered" data-bs-dismiss="modal">Cancelar</button>
            </div>

          </div>
        </div>
      </div>

    </div>
    <div class="modal" id="consultaCarrito">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
        
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Consulta de carrito de: {{ titulo }}</h4>
          </div>
          
          <!-- Modal body -->
          <div class="modal-body">
            <div v-for="(item, key) in items" :key="key" class="border-black-500 border">
              <div class="row w-full">
                <div class="col-2 flex justify-center items-center">
                  <img class="h-24 object-cover" v-if="item.imagen1" :src='item.imagen1' alt="Imagen del articulo">
                  <img class="h-24 object-cover" v-else src='../assets/no-photo.jpg' alt="Imagen del articulo">
                </div>
                <div class="col-md-8 col-10">
                  <div class="row w-full">
                    <div class="col-5">
                      <h5 class="modal-title text-left" id="exampleModalLabel">{{ item.DESCRIP_ART }}</h5>
                      <p class="modal-title text-[10px] text-left" id="exampleModalLabel">Código: {{ item.CODIGO_ART }}</p>
                    </div>
                    <div class="col-4">
                      <!-- <h5 v-if="item.PRECIO_LPI" class="modal-title text-left py-2">Precio unitario: $ {{ item.PRECIO_LPI.toFixed(2) }}</h5> -->
                      <!-- <div class="flex gap-0 md:gap-1 items-center"> -->
                        <p class=" text-sm text-left">CANTIDAD:</p>
                        <input type="number" disabled class="form-control w-24" v-model="item.cantidadPedida">
                      <!-- </div> -->
                    </div>
                    <div class="col-3">
                      <h5 v-if="item.PRECIO_LPI" class="modal-title text-left text-truered py-2">Subtotal: ${{ (item.PRECIO_LPI * item.cantidadPedida).toFixed(2) }}</h5>
                      <p v-if="item.obs" class="text-sm text-gray-400">Observacion: {{ item.obs }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Modal footer -->
          <div class="modal-footer">
            <button class="btn btn-danger bg-truered" data-bs-dismiss="modal">Cancelar</button>
          </div>
          
        </div>
      </div>



    </div>
  </template>
  
  <script>
import pedidosService from '@/services/pedidos.service';
import usuarioService from '@/services/usuario.service';

  export default {
    data() {
      return {
        carritosUsuarios: [],
        items: {},
        pedidosUsuarios: [],
        pedPendientes: true,
        pedHistoricos: true,
        titulo: '',
        index: 1,
        loading: false,
        cargando: false,
        itemsRepetir: [],
        idcli: '',
        tipo: 'p',
        razonsocialBuscador: '',
        clientes: [],
        filtroClientes: '',
      }
    },
    mounted() {
      this.cargarPendientes()
      this.cargarHistoricos()
    },
    methods: {
      repetirAusu() {
        this.pedArepetir.IDCLI_PED = this.idcli
        window.$('#repetirPedDistUsu').modal('hide')
        this.repetirPedido(this.pedArepetir)
      },
      itemsCarrito() {
        var user = JSON.parse(localStorage.getItem("user"));
        pedidosService
          .getItemsCarritoClienteSimple(user.id, this.idcli)
          .then((res) => {
            console.log(res)
          })
          .catch((err) => {
            console.log(err);
          });          
      },
      cargarClientes() {
        usuarioService.getClientes(this.$root.user.id)
          .then((res) => {
            this.clientes = res.data.map(c => ({
              id: c.ID_CLI,
              descripcion: c.RAZONSOCIAL_CLI
            }))
            this.idcli = this.clientes[0].id
          })
          .then(() => {
            this.itemsCarrito()
          })
          .catch(err => {
            console.log(err)
          })
      },
      cargarTodosLosClientes() {
        usuarioService.getAllClientes(this.$root.user.id)
          .then((res) => {
            this.clientes = res.data.map(c => ({
              id: c.ID_CLI,
              descripcion: c.RAZONSOCIAL_CLI
            }))
            this.idcli = this.clientes[0].id
          })
          .then(() => {
            this.itemsCarrito()
          })
          .catch(err => {
            console.log(err)
          })
      },
      updateIdcli() {
        this.idcli = this.clientesFiltrados[0].id
        this.itemsCarrito()
      },
      repetirPedidoCambioCli(ped) {
        this.pedArepetir = ped
        if (!this.esSupervisor && this.esVendedor) {
          this.cargarClientes();
        }
        if (this.esSupervisor) {
          this.cargarTodosLosClientes()
        }
        window.$('#repetirPedDistUsu').modal('show')
      }, 
      repetirPedido(ped) {
        this.itemsRepetir = []
        this.idcli = ''
        pedidosService.getCountItemsCarritoCliente(this.$root.user.id, ped.IDCLI_PED)
          .then((res) => {
            this.idcli = ped.IDCLI_PED
            this.res(res, ped)
          })
          .catch((err) => {
            console.log(err)
          })
      },
      res(res, ped) {
        if(res.data > 0) {
          this.pedRepetir = ped
          window.$('#borrarCarrito').modal('show')
        } else {
          this.repetirItems(ped)
        }
      },
      borrarYrepetir() {
        window.$('#borrarCarrito').modal('hide')
        if (this.esVendedor) {
          pedidosService.deleteCarritoUsuCli(this.$root.user.id, this.idcli)
            .then(() => {
              this.repetirItems(this.pedRepetir)
            })
            .catch((err) => {
              console.log(err)
            })
        }
      },
      repetirItems(ped) {
        this.cargando = true;
        console.log(ped.items)
        ped.items.forEach(item => {
          var itm = {
              id: item.id_ic ? item.id_ic : null,
              idart: item.IDART_PEDI,
              cantidad: item.CANTIDAD_PEDI,
              obs: item.OBS1_PEDI ? item.OBS1_PEDI : null,
              idcli: this.idcli
            };
          pedidosService
            .postItemsCarrito(itm)
            .catch((err) => {
              console.log(err);
            });
        })
        this.cargando = false
        this.$root.alertSucces = true
        this.$root.isAlertVisible = true
      },
      verItems(items) {
          this.items = items
          window.$('#itemsPed').modal('show')
      },
      verCarrito(id, razon, idcli) {
        pedidosService.getItemsCarritoCliente(id, idcli ? idcli : null)
          .then(res => {
            if (res.data) {
              this.items = res.data
              this.titulo = razon
              this.items.forEach((x, i) => this.buscarFotos(i))
              window.$('#consultaCarrito').modal('show')
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      buscarFotos(index) {
        pedidosService.getImagenProducto(this.items[index].IDART_IO, 1)
          .then(res => {
            if (res.data.byteLength === 0) {
              if (this.items[index]) {
                this.items[index].imagen1 = ''
              }
              return  
            }
            const imageBlob = new Blob([res.data], { type: 'image/*' })
            if (this.items[index]) {
              this.items[index].imagen1 = URL.createObjectURL(imageBlob)
            }
          })
          .catch((err) => {
            console.log(err)
            if (this.items[index]) {
              this.items[index].imagen1 = ''
            }
          })
      },
      cargarPendientes() {
        pedidosService.cargarCarritosUsuarios()
          .then((res) => {
            this.carritosUsuarios = res.data
          })
          .catch((err) => {console.log(err)})
      },
      cargarHistoricos() {
        this.loading = true
        var razon = this.razonsocialBuscador ? this.razonsocialBuscador : null
        pedidosService.cargarPedidosHistoricos(this.index, razon)
          .then((res) => {
            this.pedidosUsuarios = res.data
          })
          .catch((err) => {console.log(err)})
          .finally(() => {
            this.loading = false
          })
      },
      formatDate(dateString) {
          const date = new Date(dateString);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
      }
    },
    computed: {
      clientesFiltrados() {
        if (!this.filtroClientes) {
          return this.clientes
        } else {
          return this.clientes.filter(x => x.descripcion.toLowerCase().includes(this.filtroClientes.toLocaleLowerCase()))
        }
      },
      esVendedor() {
        return this.$root.user.tipo != "cliente";
      },
      esSupervisor() {
        return this.esVendedor && ['admin', 'supervisor'].includes(this.$root.user.tipo)
      }
    },
  };
  </script>

<style>
.arrow {
  transform: rotate(180deg);
}
</style>
